import React from 'react';
import './InfoPage.css';

function ResponsibleHosting() {
  return (
    <div className="info-page">
      <div className="info-container">
        <h1>Hospedagem Responsável</h1>

        <section className="info-section">
          <h2>Hospedando com cuidado pela sua comunidade e hóspedes</h2>
          <p>Como anfitrião Nukki, você tem a oportunidade de criar experiências positivas para os hóspedes enquanto é um membro responsável da sua comunidade. Aprenda como hospedar de forma sustentável, segura e em conformidade com regulamentações locais.</p>
        </section>

        <section className="info-section">
          <h3>Relações com a Comunidade</h3>

          <div className="feature-box">
            <h4>Seja um Bom Vizinho</h4>
            <p>Suas atividades de hospedagem afetam aqueles ao seu redor. Mantenha relações positivas com vizinhos ao:</p>
            <ul>
              <li>Manter níveis de ruído razoáveis, especialmente à noite</li>
              <li>Gerenciar chegadas e partidas de hóspedes com consideração</li>
              <li>Manter a aparência externa da sua propriedade</li>
              <li>Fornecer aos vizinhos um método de contato para preocupações</li>
              <li>Ser receptivo a questões da vizinhança</li>
            </ul>
          </div>

          <div className="feature-box">
            <h4>Prevenção de Festas</h4>
            <p>Proteja sua propriedade, vizinhos e a plataforma prevenindo festas não autorizadas:</p>
            <ul>
              <li>Defina regras claras da casa sobre reuniões e eventos</li>
              <li>Estabeleça limites de hóspedes e os faça cumprir</li>
              <li>Considere depósitos de segurança para proteção extra</li>
              <li>Use dispositivos de monitoramento de ruído (onde legal)</li>
              <li>Avalie hóspedes e fique atento a sinais de alerta</li>
            </ul>
          </div>
        </section>

        <section className="info-section">
          <h3>Conformidade Legal</h3>

          <div className="feature-box">
            <h4>Conheça Suas Leis Locais</h4>
            <p>Regulamentações de aluguel de curto prazo variam por localização. É sua responsabilidade:</p>
            <ul>
              <li>Pesquisar leis locais e regulamentações de zoneamento</li>
              <li>Obter licenças e autorizações necessárias</li>
              <li>Seguir limites de ocupação e requisitos de segurança</li>
              <li>Coletar e remeter impostos aplicáveis</li>
              <li>Cumprir com regras de associação de proprietários (condomínio)</li>
              <li>Manter-se informado sobre mudanças de regulamentação</li>
            </ul>
          </div>

          <div className="feature-box">
            <h4>Obrigações Fiscais</h4>
            <p>Renda de hospedagem é tributável. Seja um anfitrião responsável ao:</p>
            <ul>
              <li>Manter registros precisos de receitas e despesas</li>
              <li>Entender quais impostos se aplicam a você</li>
              <li>Preencher declarações fiscais apropriadamente</li>
              <li>Usar as ferramentas fiscais e documentação do Nukki</li>
              <li>Consultar um profissional tributário se necessário</li>
            </ul>
          </div>
        </section>

        <section className="info-section">
          <h3>Segurança dos Hóspedes</h3>

          <div className="feature-box">
            <h4>Medidas de Segurança</h4>
            <ul>
              <li>Instalar detectores de fumaça e alarmes de monóxido de carbono</li>
              <li>Fornecer extintores de incêndio e kits de primeiros socorros</li>
              <li>Garantir que todas as fechaduras e sistemas de segurança funcionem adequadamente</li>
              <li>Manter entradas e caminhos bem iluminados</li>
              <li>Proteger janelas e portas</li>
              <li>Remover materiais perigosos</li>
            </ul>
          </div>

          <div className="feature-box">
            <h4>Perigos da Propriedade</h4>
            <p>Divulgue e mitigue perigos potenciais:</p>
            <ul>
              <li>Piscinas, banheiras de hidromassagem e elementos aquáticos</li>
              <li>Escadas íngremes ou superfícies irregulares</li>
              <li>Preocupações com vida selvagem ou pragas</li>
              <li>Armas ou câmeras de segurança na propriedade</li>
              <li>Construção ou reformas próximas</li>
            </ul>
          </div>

          <div className="feature-box">
            <h4>Preparação para Emergências</h4>
            <ul>
              <li>Fornecer informações de contato de emergência</li>
              <li>Criar e compartilhar planos de evacuação</li>
              <li>Estocar suprimentos de emergência</li>
              <li>Compartilhar localização de desligamentos de utilidades</li>
              <li>Preparar-se para emergências relacionadas ao clima</li>
            </ul>
          </div>
        </section>

        <section className="info-section">
          <h3>Hospedagem Sustentável</h3>

          <div className="feature-box">
            <h4>Responsabilidade Ambiental</h4>
            <p>Reduza seu impacto ambiental enquanto hospeda:</p>
            <ul>
              <li>Usar eletrodomésticos com eficiência energética e iluminação LED</li>
              <li>Instalar termostatos programáveis</li>
              <li>Fornecer opções de reciclagem e compostagem</li>
              <li>Usar produtos de limpeza ecológicos</li>
              <li>Reduzir plásticos de uso único</li>
              <li>Conservar água com acessórios eficientes</li>
              <li>Escolher móveis sustentáveis</li>
            </ul>
          </div>

          <div className="feature-box">
            <h4>Dicas de Hospedagem Verde</h4>
            <ul>
              <li>Encorajar hóspedes a reutilizar toalhas e roupas de cama</li>
              <li>Fornecer informações sobre transporte público</li>
              <li>Oferecer bicicletas ou sugerir destinos a pé</li>
              <li>Apoiar negócios locais em suas recomendações</li>
              <li>Usar energia renovável quando possível</li>
              <li>Criar uma experiência de hóspede de baixo desperdício</li>
            </ul>
          </div>
        </section>

        <section className="info-section">
          <h3>Hospedagem Justa e Inclusiva</h3>

          <div className="feature-box">
            <h4>Política de Não Discriminação</h4>
            <p>Todos os anfitriões devem cumprir nossa política de não discriminação. Você não deve:</p>
            <ul>
              <li>Recusar hóspedes com base em raça, religião ou origem nacional</li>
              <li>Discriminar com base em orientação sexual ou identidade de gênero</li>
              <li>Recusar hóspedes com deficiências</li>
              <li>Cobrar preços diferentes com base em características protegidas</li>
            </ul>
          </div>

          <div className="feature-box">
            <h4>Acessibilidade</h4>
            <p>Torne seu espaço acolhedor para todos os hóspedes:</p>
            <ul>
              <li>Descrever com precisão os recursos de acessibilidade</li>
              <li>Observar quaisquer limitações ou barreiras de acesso</li>
              <li>Estar disposto a fazer acomodações razoáveis</li>
              <li>Considerar melhorias de acessibilidade</li>
            </ul>
          </div>
        </section>

        <section className="info-section">
          <h3>Anúncios Honestos e Precisos</h3>
          <p>Anfitriões responsáveis fornecem informações precisas:</p>
          <ul>
            <li>Usar fotos recentes e representativas</li>
            <li>Escrever descrições honestas do seu espaço</li>
            <li>Divulgar quaisquer problemas ou limitações antecipadamente</li>
            <li>Manter seu calendário atualizado</li>
            <li>Honrar seus compromissos com os hóspedes</li>
            <li>Responder prontamente às consultas</li>
            <li>Definir expectativas realistas</li>
          </ul>
        </section>

        <section className="info-section">
          <h3>Privacidade dos Hóspedes</h3>
          <p>Respeite a privacidade dos hóspedes e a proteção de dados:</p>
          <ul>
            <li>Nunca compartilhe informações pessoais dos hóspedes</li>
            <li>Divulgar quaisquer câmeras de segurança ou dispositivos de gravação</li>
            <li>Não colocar câmeras em espaços privados</li>
            <li>Respeitar o direito dos hóspedes ao uso tranquilo</li>
            <li>Seguir regulamentações de proteção de dados</li>
          </ul>
        </section>

        <div className="cta-section">
          <h3>Comprometa-se com a Hospedagem Responsável</h3>
          <p>Junte-se a nós na criação de um impacto positivo para hóspedes, comunidades e o planeta</p>
        </div>
      </div>
    </div>
  );
}

export default ResponsibleHosting;
